// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"a8dc8fa4","421":"2f59a6a9","583":"b54b6193","601":"b0c238ac","808":"cc66feda","891":"111d4d4f","918":"b2b9ee2b"}[chunkId] + ".chunk.js";
};